import { IPDropdown } from 'baseComponents';
import Widget, { WidgetSizes } from 'models/widget';
import { useTranslation } from 'react-i18next';

interface IWidgetSizeSelectorProps {
  widget: Widget;
  onChange: (size: WidgetSizes) => void;
}

const WidgetSizeSelector = (props: IWidgetSizeSelectorProps) => {
  const { t } = useTranslation(['widgets', 'translation']);

  const getVisualSize = (size: WidgetSizes) => {
    return ' ' + '☐'.repeat(size);
  };

  const getOptions = () => {
    const options = [];

    options.push({
      key: WidgetSizes.Small,
      text: t('widgets:SizeSelector.Small') + getVisualSize(WidgetSizes.Small),
    });
    options.push({
      key: WidgetSizes.Medium,
      text: t('widgets:SizeSelector.Medium') + getVisualSize(WidgetSizes.Medium),
    });
    options.push({
      key: WidgetSizes.Large,
      text: t('widgets:SizeSelector.Large') + getVisualSize(WidgetSizes.Large),
    });

    return options;
  };

  //
  // Main render
  //

  return (
    <IPDropdown
      selectedKey={props.widget.widgetSize}
      label={t('widgets:SizeSelector.Label')}
      options={getOptions()}
      onChange={(ev, option) => props.onChange(option?.key as WidgetSizes)}
      styles={{ root: { width: 150 } }}
    />
  );
};

export default WidgetSizeSelector;
